import { Stack, Typography } from "@mui/material";
import { ReuseModal } from "../ReuseModal";

type Variant = "auto" | "manual";

export const RestartAnalysisModal = ({
  totalCompanies,
  onSubmit,
  isOpen,
  isLoading,
  onClose,
  variant = "auto",
}: {
  totalCompanies: number;
  onSubmit: () => void;
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  variant?: Variant;
}) => {
  const onSubmitHandler = () => {
    onSubmit();
  };

  const isAuto = variant === "auto";

  return (
    <ReuseModal
      icon="warn"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmitHandler}
      title={isAuto ? "Change Roles Composition?" : "Change Job Titles?"}
      customText={
        <Stack gap="24px">
          <Typography variant="body1" color="text.secondary">
            {isAuto ? (
              <>
                After changing the buying committee roles composition, the
                discovery
                <strong>
                  {` analysis will be recalculated for ${totalCompanies} accounts.`}
                </strong>
              </>
            ) : (
              <>
                Changing job titles for this role affects how accounts are
                matched during discovery analysis.
                <strong>
                  {` ${totalCompanies} account${totalCompanies === 1 ? "" : "s"} will become available for re-analysis.`}
                </strong>
              </>
            )}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {isAuto
              ? "Previous results will be overwritten to reflect new composition."
              : "Analysis won't restart automatically. You'll be able to trigger re-analysis for these accounts whenever you're ready."}
          </Typography>
        </Stack>
      }
      submitBtnText={isAuto ? "Continue" : "Save Changes"}
      maxWidth="430px"
      isLoading={isLoading}
      isDisabled={isLoading}
      isDisabledCancelBtn={isLoading}
    />
  );
};
